// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".other-office-connection-table-component .detail-btn[data-v-4d5604a5]{width:94px}.other-office-connection-table-component .application-btn[data-v-4d5604a5]{width:124px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
